import './Init.css';
const partners = [
  { name: "Y Combinator", url: "https://www.ycombinator.com/cofounder-matching", description: "YC's official co-founder matching platform for startup founders." },
  { name: "Startup School (YC)", url: "https://www.startupschool.org", description: "YC's free online program and community for aspiring founders." },
  { name: "CoFoundersLab", url: "https://cofounderslab.com", description: "The largest network for entrepreneurs to find co-founders, advisors, and interns." },
  { name: "CoffeeSpace", url: "https://www.coffeespace.com", description: "CoffeeSpace is an AI-powered talent matching platform built for early-stage startups." },
];

const ExternalLinkIcon = () => (
  <svg className="partner-card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

const Init = () => {

  return (
    <div className="init">
      <img src="/cofounders.png" alt="Co-founders" className="init-image" />
      <section className="partners">
        <div className="section-container">
          <div className="partners-grid">
            {partners.map((partner) => (
              <a
                key={partner.name}
                href={partner.url}
                target="_blank"
                rel="noopener noreferrer"
                className="partner-card"
              >
                <div className="partner-card-header">
                  <h3>{partner.name}</h3>
                  <ExternalLinkIcon />
                </div>
                <p>{partner.description}</p>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Init;
